import i18n from 'src/lib/i18n/i18n';
import { Warning } from './Icons';

export function CancelPayment({
  onClose,
  visible,
}: {
  onClose: (close: boolean) => void;
  visible: boolean;
}) {
  return (
    <>
      <div class={`overlay ${visible ? '' : 'hidden'}`} />
      <div class={`cancelPayment ${visible ? '' : 'hidden'}`}>
        <div class="cancelPaymentHeader">
          <Warning />
          {i18n('openwebCancel.message')}
        </div>
        <div class="cancelPaymentButtons">
          <input
            type="button"
            class="button"
            value={i18n('openwebCancel.yes')}
            onClick={() => onClose(true)}
          />{' '}
          <input
            type="button"
            class="button black"
            value={i18n('openwebCancel.no')}
            onClick={() => onClose(false)}
          />
        </div>
      </div>
    </>
  );
}
